
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRolesCount }}</span>
          <span class="stats-card-label">Total Roles</span>
          <span class="stats-card-sublabel">All roles</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeRolesCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Currently active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveRolesCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Not active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRecords }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="serviceGroupFilter" class="filter-label">Service Group</label>
          <p-select id="serviceGroupFilter" [(ngModel)]="selectedServiceGroupFilter"
            (ngModelChange)="onServiceGroupFilterChange()" [options]="serviceGroups" optionLabel="name"
            optionValue="id" placeholder="All Service Groups" [showClear]="true" [filter]="true"
            filterPlaceholder="Search service group..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredRoles"
      [loading]="loading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} roles"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="title">
            Title
            <p-sortIcon field="title" />
          </th>
          <th pSortableColumn="description">
            Description
            <p-sortIcon field="description" />
          </th>
          <th pSortableColumn="serviceGroupName">
            Service Group
            <p-sortIcon field="serviceGroupName" />
          </th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-role>
        <tr [class.row-inactive]="role.isActive === false">
          <td class="td-truncate" [pTooltip]="role.title || '-'" tooltipPosition="top">{{ role.title }}</td>
          <td class="td-truncate td-description" [pTooltip]="(role.description || '-')" tooltipPosition="top">{{ role.description || '-' }}</td>
          <td class="td-truncate" [pTooltip]="role.serviceGroupName || '-'" tooltipPosition="top">{{ role.serviceGroupName || '-' }}</td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                [icon]="role.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="role.isActive ? 'success' : 'secondary'"
                [text]="true"
                (onClick)="toggleActiveStatus(role)"
                size="small"
                [pTooltip]="role.isActive ? 'Active' : 'Inactive'"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-pencil"
                (onClick)="showEditDialog(role)"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit"
                tooltipPosition="top" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="4" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No roles found</p>
              <p class="empty-description">Update filters or add a new role</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog [visible]="displayDialog" (visibleChange)="displayDialog = $event"
  [header]="dialogMode === 'add' ? 'Add Role' : 'Edit Role'"
  [modal]="true" styleClass="dialog-md" [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row two-columns">
        <div class="field" [class.field-invalid]="fieldTouched['title'] && !selectedRole.title.trim()">
          <label for="title">Title <span class="required-star">*</span></label>
          <input pInputText id="title" [(ngModel)]="selectedRole.title" placeholder="Enter role title" (blur)="fieldTouched['title'] = true" />
          <small class="field-error" *ngIf="fieldTouched['title'] && !selectedRole.title.trim()">Title is required</small>
        </div>
        <div class="field">
          <label for="serviceGroup">Service Group</label>
          <p-select id="serviceGroup" [(ngModel)]="selectedRole.serviceGroupId"
            (ngModelChange)="onServiceGroupChange()" [options]="serviceGroups" optionLabel="name"
            optionValue="id" placeholder="Select service group" [showClear]="true"
            [filter]="true" filterPlaceholder="Search service group..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="description">Description</label>
          <textarea id="description" [(ngModel)]="selectedRole.description" rows="3"
            class="p-inputtext" placeholder="Enter role description"></textarea>
        </div>
      </div>
      <div class="form-row" *ngIf="dialogMode === 'edit'">
        <div class="field">
          <label>Status</label>
          <p-button [label]="selectedRole.isActive ? 'Active' : 'Inactive'"
            [severity]="selectedRole.isActive ? 'success' : 'secondary'"
            [outlined]="!selectedRole.isActive"
            (onClick)="selectedRole.isActive = !selectedRole.isActive" size="small" />
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetRoleForm()" [text]="true" severity="secondary"
        styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveRole()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
